<template>
  <span>{{ data.vat_deadline != '' ? data.vat_deadline : '-' }}</span>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
</style>